import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { COMMERCIAL_HEATING_FAQS } from "@/components/landing/lp-commercial-heating";

import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpCommercialHeatingPage = lazyNamed(
  () => import("@/components/landing/lp-commercial-heating"),
  "LpCommercialHeating",
);

const PATH = "/commercial-heating";
const TITLE = "Gas, Boiler & Heating Programmes South Wales & South West | Framework-Ready | CRS Energy";
const DESCRIPTION =
  "Gas Safe landlord gas safety, planned boiler replacement and void heating works for councils, housing associations, FMs and main contractors. Framework-ready delivery with completion documentation.";
const BREADCRUMB_NAME = "Gas, Boiler & Heating Programmes";

export const Route = createFileRoute("/commercial-heating")({
  head: () => ({
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: BREADCRUMB_NAME,
        description: DESCRIPTION,
        serviceType: "Gas, Boiler & Heating Programmes",
        url: `${SITE.url}${PATH}`,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMMERCIAL_HEATING_FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      breadcrumbJsonLdScript(commercialBreadcrumbTrail(BREADCRUMB_NAME, PATH)),
    ],
  }),
  component: LpCommercialHeatingPage,
});
